import { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const ALLOWED_INTERVIEW_STATUSES = new Set(['active', 'scheduled']);

function useInterviewMenuAccess() {
  const [hasInterviewMenuAccess, setHasInterviewMenuAccess] = useState(false);

  useEffect(() => {
    const auth = getAuth();
    let unsubscribeInterview = () => {};

    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      unsubscribeInterview();
      setHasInterviewMenuAccess(false);

      if (!user?.uid) {
        return;
      }

      unsubscribeInterview = onSnapshot(doc(db, 'interviewCalls', user.uid), (snapshot) => {
        const status = String(snapshot.data()?.status || '').trim().toLowerCase();
        setHasInterviewMenuAccess(ALLOWED_INTERVIEW_STATUSES.has(status));
      }, () => {
        setHasInterviewMenuAccess(false);
      });
    });

    return () => {
      unsubscribeInterview();
      unsubscribeAuth();
    };
  }, []);

  return hasInterviewMenuAccess;
}

export default useInterviewMenuAccess;
